import { render } from "./ratingReview.vue?vue&type=template&id=f383b900"
import script from "./ratingReview.vue?vue&type=script&lang=js"
export * from "./ratingReview.vue?vue&type=script&lang=js"

import "./ratingReview.vue?vue&type=style&index=0&id=f383b900&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__